import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { ProcessTag } from '@core/entities/processTags'
import {
  processTagsKeys,
  RequestTypes,
} from '@core/react-query/features/processTags'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useEditProcessTag = (
  options?: UseMutationOptions<
    ProcessTag,
    RequestErrorType,
    RequestTypes['editProcessTag']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...processTagsKeys.editProcessTag,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: processTagsKeys.getProcessTags._def,
      })
    },
  })
}
